import React from 'react';
import { WhatsAppCoexistenceSettings } from '../organisms';
import { SettingsTemplate } from '../templates';

export function WhatsAppCoexistencePage() {
  return (
    <SettingsTemplate>
      <WhatsAppCoexistenceSettings />
    </SettingsTemplate>
  );
}
